const emailIsValid = (value) => {
  if (!value) return true;
  const reg = /\S+@\S+\.\S+/;
  return reg.test(value);
};

export default emailIsValid;
